import axios from "@/index";
const salePerson = {
  state: {
    salePersonList: [],
    salePersonData: [],
    opinionInfo: []
  },
  getters: {},
  actions: {
    getSalesPersonList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setSalePersonList",
                (state, { salePersonList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getSalePersonInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setSalePersonInfo",
                (state, { salePersonData: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getOpinionInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setOpinionInfo", (state, { opinionInfo: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setSalePersonList(state, action) {
      state.salePersonList = action.salePersonList;
    },
    setSalePersonInfo(state, action) {
      state.salePersonData = action.salePersonData;
    },
    setOpinionInfo(state, action) {
      state.opinionInfo = action.opinionInfo;
    }
  }
};
export default salePerson;
